<template>
  <el-dialog
    :title="competence.id ? 'Редактирование компетенции' : 'Создание компетенции'"
    :visible.sync="show"
    top="2vh"
    :close-on-click-modal="false"
  >
    <el-form
      size="small"
      ref="editForm"
      label-position="top"
      :model="competence"
      :rules="competenceRules"
      @submit.native.prevent="saveCompetence"
    >
      <el-form-item label="Название" prop="name">
        <el-input
          maxlength="1000"
          v-model="competence.name"
          ref="competenceToFocus"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="Описание" prop="description">
        <el-input
          maxlength="10000"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 6}"
          v-model="competence.description"
        ></el-input>
      </el-form-item>
      <el-form-item label="Категория" prop="category_id">
        <categories-select
          style="width: 100%"
          size="size"
          :multiple="false"
          v-model="competence.category_id"
        ></categories-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">Отмена</el-button>
      <el-button
        type="primary"
        size="small"
        :loading="loading"
        @click="saveCompetence"
      > Сохранить
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import CategoriesSelect from "@/modules/evaluation/components/CategoriesSelect.vue";

export default {
  name: "competence-edit-dialog",
  components: {CategoriesSelect},
  data() {
    return {
      show: false,
      loading: false,
      competence: {
        id: null,
        name: null,
        description: '',
        category_id: null,
      },
      competenceRules: {
        name: [{required: true, message: 'Поле обязательно для заполнения', trigger: 'blur'}],
        category_id: [{required: true, message: 'Поле обязательно для заполнения', trigger: 'change'}],
      },
    }
  },
  methods: {
    async open(competence) {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }

      this.competence = Object.assign({}, competence);
      this.show = true;
      this.$nextTick(() => this.$refs.competenceToFocus.focus());
    },
    close() {
      this.show = false;
    },
    saveCompetence() {
      if (this.competence.id) {
        this.updateCompetence();
      } else {
        this.createCompetence();
      }
    },
    createCompetence() {
      this.$refs.editForm.validate().then(()=> {
        this.loading = true;
        this.$api.evaluation.competenceCreate({
          name: this.competence.name,
          description: this.competence.description,
          category_id: this.competence.category_id,
        })
          .then(data => {
            this.$notify.success({
              title: 'Сохранено',
              message: 'Компетенция успешно создана'
            });
          })
          .finally(()=>{
            this.loading = false;
            this.close();
            this.$emit('competence-saved');
          })
      })
    },
    updateCompetence() {
      this.$refs.editForm.validate().then(()=> {
        this.loading = true;
        this.$api.evaluation.competenceUpdate({
          id: this.competence.id,
          name: this.competence.name,
          description: this.competence.description,
          category_id: this.competence.category_id,
        })
          .then(data => {
            this.$notify.success({
              title: 'Обновлено',
              message: 'Компетенция успешно обновлена'
            });
          })
          .finally(()=>{
            this.loading = false;
            this.close();
            this.$emit('competence-saved');
          })
      })
    }
  }
}
</script>

<style>

</style>